module.exports = __webpack_public_path__ + "media/components/footer/static/logo-facebook-988c4574aa6b82842b4b8f592c704444.svg";